import type {ToastOptions} from 'react-toastify';
import {toast} from 'react-toastify';
import type {NotificationData} from './NotificationContent.tsx';
import NotificationContent from './NotificationContent.tsx';

type NotifyOptions = ToastOptions<NotificationData>;

/**
 * Dispatch a notification
 * @param {NotifyOptions} options the notify options
 * @returns the notification id
 */
export const notify = (options: NotifyOptions) =>
  toast(NotificationContent, {
    type: options.type ?? 'info', // default to info
    toastId: options.toastId || options.data?.message,
    ...options,
  });

/**
 * Dispatch an info notification
 * @param {NotifyOptions} options the notify options
 * @returns the notification id
 */

export const notifyInfo = (options: NotifyOptions) =>
  notify({
    ...options,
    type: 'info',
  });

/**
 * Dispatch a success notification
 * @param {NotifyOptions} options the notify options
 * @returns the notification id
 */

export const notifySuccess = (options: NotifyOptions) =>
  notify({
    ...options,
    type: 'success',
  });

/**
 * Dispatch an error notification and set autoClose to false
 * @param {NotifyOptions} options the notify options
 * @returns the notification id
 */

export const notifyError = (options: NotifyOptions) =>
  notify({
    ...options,
    type: 'error',
    autoClose: false,
  });

/**
 * Dispatch a warning notification and set autoClose to false
 * @param {NotifyOptions} options the notify options
 * @returns the notification id
 */

export const notifyWarning = (options: NotifyOptions) =>
  notify({
    ...options,
    type: 'warning',
    autoClose: false,
  });

/**
 * Dismiss an individual notification by id
 * @param {string} id
 */
export const dismissNotification = (id: string) => {
  toast.dismiss(id);
};

/**
 * Dismiss all toast notifications
 */
export const dismissAllNotifications = () => {
  toast.dismiss();
};
